import {useEffect, useState} from 'react';
import {initial, isSuccess} from '../../common/domain/RemoteData.model';
import {requestCredentials} from '../infrastructure/UserApi';
import {remoteDataWithSetter} from '../../common/utils/remoteDataWithSetter';
import {useNavigate} from 'react-router-dom';

export const useCredentialsRequest = () => {
  const [requestRemoteData, setRequestRemoteData] = useState(initial(null));
  const navigate = useNavigate();

  const request = async (info, tenantId) => {
    await remoteDataWithSetter(setRequestRemoteData, () => requestCredentials(info, tenantId));
  };

  useEffect(() => {
    if (isSuccess(requestRemoteData)) {
      setTimeout(() => { navigate('/iniciar-sesion'); }, 4000);
    }
  }, [requestRemoteData, navigate]);

  return { requestRemoteData, request };
};
